import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { Link } from "react-router-dom";
import localization from "assets/localization/localization";

const EmpTicketsListing = ({
  getTicketsList,
  ticketsList,
  getStatusList,
  statusList,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={`${baseUrl}/employee-create-ticket`}
          className="btn btn-primary d-none d-md-inline-block"
        >
          {localization.createTicket}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </Fragment>
    );
  };

  const Headers = [
    "Ticket ID",
    "Ticket Subject",
    "Created On",
    "Status",
    "Actions",
  ];

  useEffect(() => {
    const tableData = ["ticketId", "ticketSubject", "createdDate", "status"];
    if (ticketsList !== null && ticketsList.resultSets.length > 0) {
      const data = ticketsList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({
            [key]: element[key],
          })),
          {
            Actions: {
              name: "View Details",
              link: `${baseUrl}/ticket-details/${element.ticketId}`,
            },
          }
        )
      );

      data && setListData(data);
      setPageCount(Math.ceil(ticketsList.total / ticketsList.per_page));
      setCurrentPage(ticketsList.current_page);
    } else setListData([]);
  }, [ticketsList]);

  // useEffect(() => {
  //   if (getTicketsList !== null)
  //     (async () => {
  //       setIsLoading(true);
  //       await getTicketsList();
  //       await getStatusList();
  //       setIsLoading(false);
  //     })();
  // }, [getTicketsList]);

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getTicketsList(filter, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getTicketsList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  return (
    <Layout
      title={localization.employeeTickets}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      {/* <TableSection
        data={listData}
        headers={Headers} 
        pageCount={pageCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        detailList={ ticketsList !== null && ticketsList.resultSets}
      />
      <ListFilters
        showFilter={showFilter}
        status={statusList}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        filterTicketsListing
      /> */}
    </Layout>
  );
};

export default EmpTicketsListing;
